// @flow

import gql from 'graphql-tag';

import serviceActionMetadata from 'app/graphql/fragments/service/serviceActionMetadata';
import serviceActions from 'app/graphql/fragments/service/serviceActions';
import serviceCategories from 'app/graphql/fragments/service/serviceCategories';
import serviceInfo from 'app/graphql/fragments/service/serviceInfo';
import serviceMetadata from 'app/graphql/fragments/service/serviceMetadata';

/* eslint-disable graphql/no-deprecated-fields */
// FIXME: Get rid of deprecated `Query.services` field. Being tracked here:
// https://zapierorg.atlassian.net/browse/FLX-1772
export default gql`
  ${serviceActionMetadata}
  ${serviceActions}
  ${serviceCategories}
  ${serviceInfo}
  ${serviceMetadata}

  query servicesByIds($ids: [String!]!) {
    services(ids: $ids) {
      ...serviceActionMetadata
      ...serviceActions
      ...serviceCategories
      ...serviceInfo
      ...serviceMetadata
    }
  }
`;
/* eslint-enable graphql/no-deprecated-fields */
